import React, { useState, useEffect } from "react";
import "./MicroserviceForm.css";

const MicroserviceForm = ({ 
  onSubmit, 
  initialMicroservice = null, 
  isEditing = false,
  onCancel
}) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [price, setPrice] = useState("");
  const [error, setError] = useState("");

  // Predefined categories for Digital Marketing
  const predefinedCategories = [
    "SEO",
    "Content Marketing",
    "Social Media",
    "Email Marketing",
    "PPC",
    "Web Development",
    "Analytics",
    "Web Hosting",
    "Domain Services",
    "Design",
    "Maintenance",
    "Support",
    "Other"
  ];

  // Fill form with data of the microservice to be edited
  useEffect(() => {
    if (initialMicroservice) {
      setTitle(initialMicroservice.title || "");
      setDescription(initialMicroservice.description || "");
      setCategory(initialMicroservice.category || "");
      setPrice(initialMicroservice.price ? initialMicroservice.price.toString() : "");
    } else {
      resetForm();
    }
  }, [initialMicroservice]);

  // Reset form
  const resetForm = () => {
    setTitle("");
    setDescription("");
    setCategory("");
    setPrice("");
    setError("");
  };

  // Submit form
  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    // Basic validation
    if (!title.trim()) {
      setError("Please enter a title for the microservice");
      return;
    }

    if (!price.trim() || isNaN(parseFloat(price)) || parseFloat(price) < 0) {
      setError("Please enter a valid price");
      return;
    }

    // Create microservice object
    const microserviceData = {
      title: title.trim(),
      description: description.trim(),
      category: category.trim(),
      price: parseFloat(price),
      updatedAt: Date.now()
    };

    if (!isEditing) {
      microserviceData.createdAt = Date.now();
    }

    // Save microservice
    onSubmit(microserviceData);
    resetForm();
  };

  return (
    <form className="microservice-form" onSubmit={handleSubmit}>
      <div className="microservice-form__header">
        <h3 className="microservice-form__title">
          {isEditing ? "Edit Microservice" : "Create New Microservice"}
        </h3>
      </div>
      
      {error && <div className="microservice-form__error">{error}</div>}
      
      <div className="microservice-form__group">
        <label htmlFor="title" className="microservice-form__label">
          Title <span className="microservice-form__required">*</span>
        </label>
        <input
          type="text"
          id="title"
          className="microservice-form__input"
          placeholder="e.g. SEO Analysis"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
      </div>
      
      <div className="microservice-form__group">
        <label htmlFor="description" className="microservice-form__label">Description</label>
        <textarea
          id="description"
          className="microservice-form__textarea"
          placeholder="Detailed description of the microservice..."
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows={4}
        />
        <p className="microservice-form__hint">A precise description helps in selecting the appropriate microservices for an offer.</p>
      </div>
      
      <div className="microservice-form__row">
        <div className="microservice-form__group">
          <label htmlFor="category" className="microservice-form__label">Category</label>
          <select
            id="category"
            className="microservice-form__select"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="">-- Select category --</option>
            {predefinedCategories.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </div>
        
        <div className="microservice-form__group">
          <label htmlFor="price" className="microservice-form__label">
            Price (€) <span className="microservice-form__required">*</span>
          </label>
          <input
            type="number"
            id="price"
            className="microservice-form__input"
            placeholder="e.g. 49.99"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            step="0.01"
            min="0"
            required
          />
        </div>
      </div>
      
      <div className="microservice-form__actions">
        <button 
          type="button" 
          className="microservice-form__cancel-btn"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button 
          type="submit" 
          className="microservice-form__submit-btn"
        >
          {isEditing ? "Update" : "Create"}
        </button>
      </div>
    </form>
  );
};

export default MicroserviceForm; 